module.exports = __webpack_public_path__ + "static/media/unicorn-1.4b005022.png";